import { Grid, GridItem, Heading } from '@chakra-ui/react';
import { FC } from 'react';
import { DownloadableInterface } from '../../types/stock';
import { DownloadbleDocument } from './DownloadableDocument';
import { DownloadbleImage } from './DownloadableImage';

type Props = {
    downloadableCollection: DownloadableInterface[];
};

export const DownloadableCollection: FC<Props> = ({
    downloadableCollection,
}) => {
    if (!downloadableCollection.length) {
        return null;
    }

    return (
        <>
            <Heading size={'md'} color={'secondary'} mb={4}>
                Downloads
            </Heading>

            <Grid
                gridTemplateColumns={{
                    base: 'repeat(2, 1fr)',
                    md: 'repeat(4, 1fr)',
                    lg: 'repeat(5, 1fr)',
                }}
                gap={4}
            >
                {downloadableCollection.map((downloadable) => (
                    <GridItem key={downloadable.url}>
                        {downloadable.type === 'image' && (
                            <DownloadbleImage downloadable={downloadable} />
                        )}

                        {downloadable.type === 'document' && (
                            <DownloadbleDocument downloadable={downloadable} />
                        )}
                    </GridItem>
                ))}
            </Grid>
        </>
    );
};
